/** @jsxImportSource @emotion/react */

import React from 'react'
import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox'

interface PropsType extends CheckboxProps {}

export const Checkbox = (props: PropsType) => {
	const label = { inputProps: { 'aria-label': 'Checkbox demo' } }

	return <MuiCheckbox {...label} {...props} />
}
